export enum PreviewFileType {
    PDF = 'PDF',
    IMAGE = 'IMAGE',
    DOCX = 'DOCX'
}